<template>
  <router-view></router-view>
</template>

<script>
import {
  faDictMap,
  inDictMap,
} from "@/utils/auth.js";
import { getDictMap } from "@/api/api.js";
export default {
  name: "App",
  // methods: {
  //   getNavMenu() {
  //     getOneColumn({}).then((res) => {
  //       localStorage.setItem(cmNavMenu, JSON.stringify(res));
  //     });
  //   },
  //   loadSiteInfo() {
  //     getSiteInfo({ current: 1, size: 10 }).then((res) => {
  //       let info = res.records[0];
  //       localStorage.setItem(siteInfo, JSON.stringify(info));
  //       localStorage.setItem(companyName, info.company);
  //     });
  //   },
  // },
  created() {
    // this.getNavMenu();
    // this.loadSiteInfo();

    getDictMap({ dictTypeId: "1528672437664980994" }).then((res) => {
      //立卷审查表办理环节 key:faStatus
      localStorage.setItem(faDictMap.faStatus, JSON.stringify(res));
    });
    getDictMap({ dictTypeId: "1528673508315602945" }).then((res) => {
      //立卷审查表办结结论 key:faResult
      localStorage.setItem(faDictMap.faResult, JSON.stringify(res));
    });
    getDictMap({ dictTypeId: "1528686001863741442" }).then((res) => {
      //临床评价方式 key:faWay
      localStorage.setItem(faDictMap.faWay, JSON.stringify(res));
    });
    getDictMap({ dictTypeId: "1528921124567650306" }).then((res) => {
      //创新医疗表办理环节 key:inStatus
      localStorage.setItem(inDictMap.inStatus, JSON.stringify(res));
    });
    getDictMap({ dictTypeId: "1528921274287525890" }).then((res) => {
      //创新医疗表办理结论 key:inResult
      localStorage.setItem(inDictMap.inResult, JSON.stringify(res));
    });
    getDictMap({ dictTypeId: "1528923593066549249" }).then((res) => {
      //创新医疗表的创新理由 key:inReason
      localStorage.setItem(inDictMap.inReason, JSON.stringify(res));
    });
  },
};
</script>

<style>
</style>
